import React, { useCallback, useEffect, useState } from "react";
import DataTableLayer from "../../components/DataTableLayer";
import PostByAgg from "../../utils/axios";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import AdminListForm from "./AdminListForm";
import ModalAlert from "../../components/ModalAlert";
import LottieLoading from "../../components/child/LottieLoading";
const AdminList = () => {

  const {roleCode} = useAuth()
  const [data,setData] = useState([]);
  const [openModal,setOpenModal] = useState(false)
  const [openModalError, setOpenModalError] = useState(<div></div>)
  const [selectedRow,setSelectedRow] = useState(null)
  const [action,setAction] = useState('')
  const [pagination, setPagination] = useState({
          pageIndex: 0,
          pageSize: 10,
          totalRecords: 10,
          totalPages: 0,
      });
  const [isLoading, setIsLoading] = useState(false)

  const columns = [
    {
      header: "User Name",
      accessorKey: "username",
    },
    {
      header: "Full Name",
      accessorKey: "full_name",
    },
    {
      header: "Email",
      accessorKey: "email",
    },
    {
      header: "Role",
      accessorKey: "role_name",
    },
    {
      header: "Status",
      accessorKey: "status_name",
      cell: ({ row }) => {
        const status = row.original.status_name;
        if (status === 'ACTIVE') {
          return <span className="text-success">{status}</span>;
        } else if (status === 'WAITING') {
          return <span className="text-warning">{status}</span>;
        } else {
          return <span className="text-muted">{status}</span>;
        }
      },
    },
    // Kondisional kolom Action
    ...(roleCode !== 'RL2411065833191'
      ? [
          {
            id: 'action',
            header: 'Action',
            accessorKey: 'action',
            cell: ({ row }) =>
              roleCode === 'RL2411062373407' && (
                <div className="dropdown">
                  <button
                    className="btn px-18 py-11 text-primary-light"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <Icon icon="ph:dots-three-outline-fill" className="menu-icon" />
                  </button>
                  <ul className="dropdown-menu">
                    {/* <li>
                      <Link
                        className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                        to="#"
                        onClick={() => handleAction('edit', row)}
                      >
                        Edit
                      </Link>
                    </li> */}
                    <li>
                      <Link
                        className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                        to="#"
                        onClick={() => handleAction('view', row)}
                      >
                        View
                      </Link>
                    </li>
                    {/* <li>
                      <Link
                        className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                        to="#"
                        onClick={() => handleAction('delete', row)}
                      >
                        Delete
                      </Link>
                    </li> */}
                  </ul>
                </div>
              ),
          },
        ]
      : []),
  ];



  const ListAdmin = () => {
    setIsLoading(true);
    const url = 'user/um/v1/user-admin'
    PostByAgg({
      url,
      body:{
        "keyword":"",
        "page":pagination.pageIndex + 1,
        "rows":pagination.totalRecords,
      },
      onResponse : onResponseListAdmin,
      onError: onErrorListAdmin
    })
  }


  function onResponseListAdmin(response) {
    console.log("response Admin List",response.data)
    if(response.data.code ==="2002000"){
      const totalRecords = response.data.data.total;
      const totalPages = Math.ceil(totalRecords / pagination.pageSize);
          setPagination((prev) => ({
              ...prev,
              totalRecords: totalRecords,
              totalPages: totalPages,
              pageSize: totalRecords,
              // pageIndex: 0,
            }));
      setIsLoading(false)
      setData(response.data.data.list_user)
    }else{
      setIsLoading(false)
      setData([])
    }
  }

  function onErrorListAdmin(error) {
    console.log("error Admin List",error)
    if(error.response.data.code === "4003400"){
      setOpenModalError(
        <ModalAlert
          show={true}
          type={"failed"}
          text={error.response.data.message.id}
          action={() => {}}
        />
      )
    }
    else{
      setOpenModalError(
        <ModalAlert
          show={true}
          type={"failed"}
          text={error.response.data.message.id}
          action={() => {}}
        />
      )
    }
  }

  const handleCreate = () =>{
    setOpenModal(true)
    setSelectedRow({})
    setAction('create')
  }

  const handleAction = (actionType, row) => {
      if (row && row.original) {
        console.log(`Action: ${actionType}, Row ID: ${row.original.id}`);
        setAction(actionType);
        setSelectedRow(row.original);  // Set the selected row with actual data
        setOpenModal(true);
    } else {
        console.error("Invalid row data", row);
    }
  }

  useEffect(() => {
    ListAdmin()
  }, [pagination.pageIndex, pagination.pageSize])

  const refreshData = () => {
    ListAdmin();
  }


  return (
    <div>
      <DataTableLayer
        data={data}
        columns={columns}
        title={"Admin List"}
        btnTitle={"Create Admin"}
        showButton={roleCode === 'RL2411062373407' ? true : false }
        onClick={handleCreate}
      />

      {openModal && (
          <AdminListForm
              open={openModal}
              onClose={() => setOpenModal(false)} 
              selectedRow={selectedRow}
              action={action}
              refreshData={refreshData}
          />
)}
    {isLoading && <LottieLoading text="Loading..." />}
    {openModalError}
    </div>
  )
};

export default AdminList;